export default __webpack_public_path__ + "static/media/google.b731e9d9.svg";